import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59b0a45a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CLink: require('@chakra-ui/vue').CLink, CFlex: require('@chakra-ui/vue').CFlex, CImage: require('@chakra-ui/vue').CImage, CBox: require('@chakra-ui/vue').CBox, CButton: require('@chakra-ui/vue').CButton, CText: require('@chakra-ui/vue').CText, CInput: require('@chakra-ui/vue').CInput, CGrid: require('@chakra-ui/vue').CGrid})
